export enum BoipaAuthTypeEnum {
  PURCHASE = 'PURCHASE',
  AUTH = 'AUTH',
  VERIFY = 'VERIFY'
}
